export default __webpack_public_path__ + "static/portica-image-d7782133a5287c3efc93ccb940f9efb3.png";